// Initial file list view
const FETCH_INVOICE_LIST_REQUEST = 'FETCH_INVOICE_LIST_REQUEST';
const FETCH_INVOICE_LIST_SUCCESS = 'FETCH_INVOICE_LIST_SUCCESS';
const FETCH_INVOICE_LIST_ERROR = 'FETCH_INVOICE_LIST_ERROR';

// Update Invoice Payment Status
const UPDATE_INVOICE_PAYMENT_STATUS_REQUEST =
    'UPDATE_INVOICE_PAYMENT_STATUS_REQUEST';
const UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS =
    'UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS';
const UPDATE_INVOICE_PAYMENT_STATUS_ERROR =
    'UPDATE_INVOICE_PAYMENT_STATUS_ERROR';
const UPDATE_INVOICE_PAYMENT_STATUS_RESET =
    'UPDATE_INVOICE_PAYMENT_STATUS_RESET';

// file download
const DOWNLOAD_INVOICE_FILE_REQUEST = 'DOWNLOAD_INVOICE_FILE_REQUEST';
const DOWNLOAD_INVOICE_FILE_SUCCESS = 'DOWNLOAD_INVOICE_FILE_SUCCESS';
const DOWNLOAD_INVOICE_FILE_ERROR = 'DOWNLOAD_INVOICE_FILE_ERROR';

// Generate Report
const GENERATE_REPORT_INVOICE_REQUEST = 'GENERATE_REPORT_INVOICE_REQUEST';
const GENERATE_REPORT_INVOICE_SUCCESS = 'GENERATE_REPORT_INVOICE_SUCCESS';
const GENERATE_REPORT_INVOICE_ERROR = 'GENERATE_REPORT_INVOICE_ERROR';

// Show and hide loaders
const HIDE_INVOICE_LOADER = 'HIDE_INVOICE_LOADER';
const SHOW_INVOICE_LOADER = 'SHOW_INVOICE_LOADER';

export {
    FETCH_INVOICE_LIST_REQUEST,
    FETCH_INVOICE_LIST_SUCCESS,
    FETCH_INVOICE_LIST_ERROR,
    HIDE_INVOICE_LOADER,
    SHOW_INVOICE_LOADER,
    DOWNLOAD_INVOICE_FILE_REQUEST,
    DOWNLOAD_INVOICE_FILE_SUCCESS,
    DOWNLOAD_INVOICE_FILE_ERROR,
    GENERATE_REPORT_INVOICE_REQUEST,
    GENERATE_REPORT_INVOICE_SUCCESS,
    GENERATE_REPORT_INVOICE_ERROR,
    UPDATE_INVOICE_PAYMENT_STATUS_REQUEST,
    UPDATE_INVOICE_PAYMENT_STATUS_SUCCESS,
    UPDATE_INVOICE_PAYMENT_STATUS_ERROR,
    UPDATE_INVOICE_PAYMENT_STATUS_RESET,
};
